<template>
  <section
    id="open-positions"
    class="careers module">
    <div class="container">
      <div class="careers-head">
        <div class="careers-head-content">
          <div
            class="headline h2"
            v-html="data.careers_headline"></div>
          <div
            class="text editor-formatting"
            v-html="data.careers_text"></div>
        </div>
        <div
          v-if="depts.length"
          class="category-dropdown"
          data-lenis-prevent>
          <div
            class="category-btn"
            :class="{ open: isOpen }"
            @click="open">
            <div class="name">
              {{ activeDepartment ? activeDepartment : 'See All Departments' }}
            </div>
            <img
              class="arrow"
              src="@/assets/img/dropdown-arrow.svg"
              alt="Drawer Arrow" />
          </div>
          <Vue3SlideUpDown v-model="isOpen">
            <ul>
              <li
                v-if="activeDepartment"
                key="dept-0"
                @click="filterCareers(null, null)">
                See All Departments
              </li>

              <template v-for="department in depts">
                <li
                  v-if="department.id != 4010309006"
                  :key="department.id"
                  :class="{ active: activeDepartment == department.name }"
                  @click="filterCareers(department.name, department.id)">
                  {{ department.name }}
                </li>
              </template>
            </ul>
          </Vue3SlideUpDown>
        </div>
      </div>
    </div>
    <div class="container large">
      <div
        v-if="filteredCareers"
        class="careers-list">
        <Department
          v-for="department in filteredCareers"
          :key="department.id"
          :department="department" />
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
   {
    "NAME": "CareersComponent",
    "CLASSNAME": "careers",
    "URL": "http://insitro.local/test/"
   }
  #ENDMETA */
import { onMounted, ref } from 'vue'
import Department from '@/components/modules/Careers/Department.vue'
import { Vue3SlideUpDown } from 'vue3-slide-up-down'
import axios from 'axios'

defineProps(['data'])

const careers = ref()
const activeDepartment = ref()
const depts = ref([])
const filteredCareers = ref()
const isOpen = ref(false)

const open = () => {
  isOpen.value = !isOpen.value
}

const getCareers = () => {
  axios
    .get(
      'https://boards-api.greenhouse.io/v1/boards/insitro/departments?render_as=tree'
    )
    .then((response) => {
      careers.value = response.data.departments.slice(0, -1)
      filteredCareers.value = careers.value
    })
    .catch((error) => {
      console.log(error)
    })
}

const getDepartments = () => {
  axios
    .get('https://boards-api.greenhouse.io/v1/boards/insitro/departments')
    .then((response) => {
      const trimmedDepts = response.data.departments.slice(0, -1)

      trimmedDepts.forEach((item) => {
        if (item.parent_id == null) {
          depts.value.push(item)
        }
      })
    })
    .catch((error) => {
      console.log(error)
    })
}

const filterCareers = (name, id) => {
  isOpen.value = false

  if ((name, id)) {
    axios
      .get(
        `https://boards-api.greenhouse.io/v1/boards/insitro/departments/${id}?render_as=tree`
      )
      .then((response) => {
        activeDepartment.value = name
        filteredCareers.value = []
        filteredCareers.value.push(response.data)
      })
      .catch((error) => {
        console.log(error)
      })
  } else {
    filteredCareers.value = careers.value
    activeDepartment.value = ''
  }
}

onMounted(() => {
  getCareers()
  getDepartments()
})
</script>

<style lang="scss">
.careers {
  .careers-head {
    position: relative;
    display: flex;
    padding: 40px 0 70px;
    margin: 0 0 30px;
    border-top: 1px solid $white;

    @include tablet-landscape(1) {
      padding-bottom: 100px;
    }

    @include mobile {
      flex-direction: column;
      padding: 40px 0 0;
      margin: 0 0 20px;
    }

    .careers-head-content {
      max-width: 452px;

      @include mobile {
        margin: 0 0 20px;
      }

      .text {
        max-width: 390px;
        margin: 20px 0 0;
      }
    }

    .category-dropdown {
      position: absolute;
      top: 40px;
      right: 0;
      width: 350px;
      max-width: 100%;
      max-height: 300px;
      overflow: auto;

      @include tablet-landscape(1) {
        top: calc(100% - 70px);
        right: initial;
        left: 0;
      }

      @include mobile {
        position: relative;
        top: 0;
        width: 100%;
      }
    }
  }
}
</style>
